export const analyticsEn = {
  bookingAnalytics: {
    navigation: {
      analytics: 'Analytics',
    },
    title: 'Booking Analytics',
    description: 'Track your studio performance and booking behavior',
    banner: 'Analytics are tracked from the public booking page. Data collection starts when users visit your studio page.',

    tabs: {
      overview: 'Overview',
      funnel: 'Booking Funnel',
      performance: 'Performance',
      behavior: 'User Behavior',
    },

    overview: {
      total_views: 'Total Views',
      booking_starts: 'Booking Starts',
      completions: 'Completions',
      conversion_rate: 'Conversion Rate',
      all_time: 'All time',
      users_who_started: 'Users who started booking',
      successful_bookings: 'Successful bookings',
      view_to_booking: 'View to booking',
    },

    funnel: {
      title: 'Booking Funnel Analysis',
      description: 'Track how users progress through the booking process',
      studio_views: 'Studio Page Views',
      booking_starts: 'Started Booking',
      room_selections: 'Selected Room',
      date_selections: 'Selected Date/Time',
      completions: 'Completed Booking',
    },

    performance: {
      coming_soon: 'Detailed performance metrics coming soon. Track popular rooms, time slots, and booking patterns.',
    },

    behavior: {
      coming_soon: 'User behavior analytics coming soon. Understand device usage, engagement patterns, and user interactions.',
    },

    coming_soon: {
      title: 'Detailed Analytics Coming Soon',
      description: 'We are currently collecting analytics data from your booking page. Once sufficient data is collected, you will see detailed charts, graphs, and insights about your studio performance, popular booking times, room preferences, and conversion metrics.',
    },

    sharing: {
      title: 'Sharing Analytics',
      description: 'Track how your studio is being shared and measure referral success',
      no_data: 'No sharing data yet. Share your studio to start tracking!',

      overview: {
        total_shares: 'Total Shares',
        total_clicks: 'Link Clicks',
        total_bookings: 'Bookings from Shares',
        total_revenue: 'Revenue from Shares',
        conversion_rate: 'Share Conversion Rate',
        click_to_view: 'Click to View Rate',
        view_to_booking: 'View to Booking Rate',
      },

      funnel: {
        title: 'Sharing Conversion Funnel',
        description: 'Track how shared links convert to bookings',
        clicks: 'Link Clicks',
        views: 'Studio Views',
        booking_starts: 'Booking Started',
        completions: 'Bookings Completed',
      },

      methods: {
        title: 'Share Method Performance',
        description: 'See which platforms drive the most bookings',
      },

      leaderboard: {
        title: 'Top Sharers',
        description: 'Users who generated the most revenue through sharing',
        rank: 'Rank',
        name: 'Name',
        shares: 'Shares',
        bookings: 'Bookings',
        revenue: 'Revenue',
        rewards: 'Rewards',
      },
    },
  },
};
